import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import {
  FacebookIcon,
  GithubIcon,
  GmailIcon,
  LinkedInIcon,
  MenuIcon,
  WhatsappIcon,
} from "../icons/icons";
import { AppContext, IAppContextState } from "../../App";

function HeaderComponent() {
  const { isCollapsedSidebarState } = useContext<IAppContextState | any>(
    AppContext
  );
  const [isCollapsedSidebar, setIsCollapsedSidebar] = isCollapsedSidebarState;
  const path = useLocation().pathname;
  let headerTitle = "";
  if (path === "/") {
    headerTitle = "Welcome to 3z4z Portfolio";
  }
  if (path === "/about-me") {
    headerTitle = "About Me";
  }
  if (path === "/my-services") {
    headerTitle = "My Services";
  }
  if (path === "/my-projects") {
    headerTitle = "My Projects";
  }
  if (path === "/contact") {
    headerTitle = "Contact Me";
  }
  return (
    <>
      <div className=" flex justify-between items-center bg-gray-800 h-[60px] border-b border-gray-600 px-3">
        <div className="flex items-center">
          <button
            className="me-4 w-7 h-7 flex justify-center items-center text-gray-400 md:hover:text-gray-200 transition-all"
            onClick={() => setIsCollapsedSidebar(!isCollapsedSidebar)}
          >
            <MenuIcon />
          </button>
          <p className="text-gray-200 font-medium hidden sm:inline-block">
            {headerTitle}
          </p>
        </div>
        <nav className="flex">
          <a
            className="me-3 fill-gray-400 hover:fill-gray-200 transition-all"
            href="http://www.github.com/3z4z"
            title="See my Github page"
            target="_blank"
            rel="noreferrer"
          >
            <GithubIcon />
          </a>
          <a
            className="me-3 fill-gray-400 hover:fill-gray-200 transition-all"
            href="https://www.linkedin.com/in/md-salmanezaz/"
            title="See my LinkedIn page"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon />
          </a>
          <a
            className="me-3 fill-gray-400 hover:fill-gray-200 transition-all"
            href="https://wa.me/8801632095012"
            title="Send WhatsApp message"
            target="_blank"
            rel="noreferrer"
          >
            <WhatsappIcon />
          </a>
          <a
            className="me-3 fill-gray-400 hover:fill-gray-200 transition-all"
            href="https://fb.me/sakib.salmanezaz.1"
            title="See my Facebook profile"
            target="_blank"
            rel="noreferrer"
          >
            <FacebookIcon />
          </a>
          <a
            className="fill-gray-400 hover:fill-gray-200 transition-all"
            href="mailto:md.salmanezaz@gmail.com"
            title="Send email to md.salmanezaz@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <GmailIcon />
          </a>
        </nav>
      </div>
    </>
  );
}

export default HeaderComponent;
